import { DashboardLessonProgressFilters } from '@/data/services/dashboardLessonProgress';

type LessonShellParams = {
  lessonId?: number;
  courseProgressId?: number;
};

export default function lessonShellQueryFilters({
  lessonId,
  courseProgressId,
}: LessonShellParams): DashboardLessonProgressFilters {
  return {
    courseProgressId: courseProgressId ? [courseProgressId] : undefined,
    lesson: lessonId ? [lessonId] : undefined,
    pageSize: 1,
  };
}
